import { css, cx } from '@flipster/styled-system/css';
import { flex, hstack } from '@flipster/styled-system/patterns';

interface Props {
  step: number;
  totalSteps: number;
}

const Step = ({ step, totalSteps }: Props) => {
  if (totalSteps === 1) {
    return null;
  }

  return (
    <ul className={hstack({ gap: 8 })}>
      {Array.from({ length: totalSteps }).map((_, i) => (
        <li
          key={i + 1}
          className={cx(
            flex({
              justify: 'center',
              align: 'center',
              width: 24,
              height: 24,
              rounded: 12,
              textStyle: 'Text/M/Strong',
            }),
            i === step && css({ color: 'inverse.black', background: 'inverse.white' }),
            i !== step && css({ color: 'content.default.level-1', background: 'background.interaction.disabled' }),
          )}
        >
          {i + 1}
        </li>
      ))}
    </ul>
  );
};

export default Step;
